import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const ImageIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue3f4'}</MuiIcon>
    );
}
